import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const normalizeRole = (role) => {
  const r = String(role || '').trim().toLowerCase();
  // Map common system-admin aliases to a single value.
  if (r === 'system_admin' || r === 'system-admin' || r === 'system administrator' || r === 'admin') return 'admin';
  if (r === 'office-admin' || r === 'office administrator' || r === 'office administrator') return 'office_admin';
  return r;
};

const RoleRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;

  const userRole = normalizeRole(user.role);
  const normalizedAllowed = allowedRoles.map(normalizeRole);

  const allowed = normalizedAllowed.includes(userRole);

  if (!allowed) {
    // Hard redirect: for non-admin trying to access admin-only pages
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleRoute;

